const accountLoginTrigger = document.querySelector('[data-account-login-trigger]');
const accountLoginDialog = document.querySelector('#house-of-aarvi-account-login');

if (accountLoginTrigger && accountLoginDialog) {
  const openAccountLogin = async () => {
    await customElements.whenDefined('dialog-component');
    accountLoginDialog.showDialog();
  };

  accountLoginTrigger.addEventListener('click', openAccountLogin);

  accountLoginDialog.addEventListener('dialog:open', () => {
    accountLoginTrigger.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(() => {
      accountLoginDialog.querySelector('input[type="tel"]')?.focus();
    });
  });

  accountLoginDialog.addEventListener('dialog:close', () => {
    accountLoginTrigger.setAttribute('aria-expanded', 'false');
    accountLoginTrigger.focus();
  });
}
